(function () {
  const CHECKOUT_SELECTORS =
    'button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, #cart-checkout';
  const DELIVERY_DETAILS_IDS = ['Details-Wunschlieferdatum-Cart', 'Details-Wunschlieferdatum-Drawer'];
  const NUDGE_DELAYS_MS = [0, 400, 1200, 2500, 4500];
  const UNLOCK_STYLE_ID = 'freilaender-bird-checkout-unlock';
  const NOOP = function FreilaenderBirdCheckoutNoop() {};

  function isCartPage() {
    const pageCheckout = document.getElementById('checkout');
    if (pageCheckout && pageCheckout.getAttribute('form') === 'cart') return true;
    return /\/cart(?:\/|$|\?)/.test(window.location.pathname);
  }

  function getCartPageScope() {
    return document.getElementById('main-cart-footer') || document.querySelector('cart-items') || document;
  }

  function getBirdSlotsBox(scope) {
    const root = scope || document;
    return root.querySelector('#birdchime-slots-box');
  }

  function openDeliveryAccordion(scope) {
    const root = scope || document;
    DELIVERY_DETAILS_IDS.forEach((id) => {
      const details = root.querySelector(`#${id}`);
      if (details) details.open = true;
    });
  }

  function nudgeBirdSlotsBox(scope) {
    const box = getBirdSlotsBox(scope);
    if (!box || box.childElementCount > 0) return;
    box.replaceWith(box.cloneNode(true));
  }

  /**
   * Bird-App-CSS sperrt Checkout pauschal:
   * button#checkout, button[name=checkout] { pointer-events:none; opacity:.4 }
   */
  function injectCheckoutUnlockStyles() {
    if (document.getElementById(UNLOCK_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = UNLOCK_STYLE_ID;
    style.textContent = [
      'button#checkout,',
      'button#CartDrawer-Checkout,',
      'button.cart__checkout-button[name="checkout"],',
      'form#cart button[name="checkout"],',
      'form#CartDrawer-Form button[name="checkout"] {',
      '  pointer-events: auto !important;',
      '  opacity: 1 !important;',
      '  cursor: pointer !important;',
      '}',
      'button#checkout[disabled],',
      'button#CartDrawer-Checkout[disabled],',
      'button.cart__checkout-button[name="checkout"][disabled],',
      'form#cart button[name="checkout"][disabled],',
      'form#CartDrawer-Form button[name="checkout"][disabled] {',
      '  pointer-events: none !important;',
      '  opacity: 0.5 !important;',
      '  cursor: not-allowed !important;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function stripBirdListenerFromButtons(listener) {
    if (typeof listener !== 'function') return;

    document.querySelectorAll(CHECKOUT_SELECTORS).forEach((button) => {
      button.removeEventListener('click', listener, true);
      button.classList.remove('birdchime-disable-node');
      button.removeAttribute('aria-disabled');
    });
  }

  /**
   * Bird hängt BirdchimeCheckoutEventListener (capture) an jeden Checkout-Button
   * und macht preventDefault — auch ohne Widget (z.B. Festtagsgeflügel auf /cart).
   * Wunschlieferdatum ist optional → Listener entfernen und zukünftige Blocker neutralisieren.
   */
  function neutralizeBirdCheckoutBlock() {
    injectCheckoutUnlockStyles();

    const existing = window.BirdchimeCheckoutEventListener;
    stripBirdListenerFromButtons(existing);

    try {
      Object.defineProperty(window, 'BirdchimeCheckoutEventListener', {
        configurable: true,
        enumerable: true,
        get() {
          return NOOP;
        },
        set(fn) {
          if (typeof fn === 'function') {
            queueMicrotask(() => stripBirdListenerFromButtons(fn));
          }
        },
      });
    } catch (error) {
      window.BirdchimeCheckoutEventListener = NOOP;
    }

    stripBirdListenerFromButtons(NOOP);
  }

  function scheduleBirdInit(scope) {
    openDeliveryAccordion(scope);
    NUDGE_DELAYS_MS.forEach((delay) => {
      window.setTimeout(() => nudgeBirdSlotsBox(scope), delay);
    });
  }

  function initCartPageBird() {
    neutralizeBirdCheckoutBlock();
    if (!isCartPage()) return;
    scheduleBirdInit(getCartPageScope());
  }

  function initDrawerBird() {
    neutralizeBirdCheckoutBlock();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    scheduleBirdInit(drawer);
  }

  neutralizeBirdCheckoutBlock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPageBird);
  } else {
    initCartPageBird();
  }

  // Bird disableCheckout läuft oft erst auf DOMContentLoaded — danach nochmal lösen.
  window.setTimeout(neutralizeBirdCheckoutBlock, 0);
  window.setTimeout(neutralizeBirdCheckoutBlock, 500);
  window.setTimeout(neutralizeBirdCheckoutBlock, 1500);
  window.setTimeout(neutralizeBirdCheckoutBlock, 3000);

  document.addEventListener('cart-drawer:opened', initDrawerBird);
})();
